export default "__VITE_ASSET__Bn8jd3n$__"